import { render, staticRenderFns } from "./selectpop.vue?vue&type=template&id=281d9a14&scoped=true"
import script from "./selectpop.vue?vue&type=script&lang=js"
export * from "./selectpop.vue?vue&type=script&lang=js"
import style0 from "./selectpop.vue?vue&type=style&index=0&id=281d9a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281d9a14",
  null
  
)

export default component.exports